/* eslint-disable no-param-reassign */
import axios from 'axios';
import { getDataUrl } from '../../../Endpoints/Endpoints';

const setParams = (params, action) => {
  if (!params.token) params.token = localStorage.getItem('token');
  if (!params.action) params.action = action;
  return params;
};

const createFormData = (files, params) => {
  const formData = new FormData();
  Object.keys(files).forEach((fileName) => {
    const fileValue = files[fileName];
    if (Array.isArray(fileValue)) {
      fileValue.forEach((file) => {
        if (file) {
          formData.append(`${fileName}[]`, file);
        }
      });
      return;
    }
    if (fileValue) {
      formData.append(fileName, fileValue);
    }
  });

  Object.keys(params).map((key) => {
    let item = params[key];
    item = key === 'params' ? JSON.stringify(params[key]) : item;
    formData.append(key, item);
    return true;
  });
  return formData;
};

export const NetworkRequestBlob = async (
  endpoint = '',
  params = {},
  action = ''
) => {
  const { ...restParams } = params;

  return axios.post(
    getDataUrl()[endpoint],
    {
      params: setParams(restParams, action)
    },
    { responseType: 'blob' }
  );
};

export const NetworkRequest = async (
  endpoint = '',
  params = {},
  action = ''
) => {
  const { signal, ...restParams } = params;

  return axios.post(
    getDataUrl()[endpoint],
    {
      params: setParams(restParams, action)
    },
    { signal }
  );
};

export const NetworkRequestMultipart = async (
  endpoint = '',
  params = {},
  fileNames = [],
  action = ''
) => {
  const formattedParams = setParams(params, action);
  const files = {};
  fileNames.forEach((fileName) => {
    const file = params[fileName];
    delete formattedParams[fileName];
    files[fileName] = file;
  });
  const formData = createFormData(files, { params: formattedParams });

  // console.log(
  //   '🚀 ~ formData inside NetworkRequestMultipart:',
  //   Object.fromEntries(formData.entries())
  // );

  return axios.post(getDataUrl()[endpoint], formData);
};
